import React, { useState } from 'react';

const TrophyIcon = ({ className = 'w-5 h-5', color = 'currentColor' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="square" strokeLinejoin="miter">
    <path d="M4 6H20C21 6 22 7 22 8V10C22 11 21 12 20 12H4C3 12 2 11 2 10V8C2 7 3 6 4 6Z" strokeWidth="2.5" fill="none" />
    <path d="M7 12V16C7 18 9 20 12 20C15 20 17 18 17 16V12" strokeWidth="2.5" fill="none" />
    <path d="M7 12L5 14" strokeWidth="2.5" />
    <path d="M17 12L19 14" strokeWidth="2.5" />
    <path d="M10 8L12 6L14 8L14 10L12 12L10 10Z" strokeWidth="2.5" fill="none" />
  </svg>
);

const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const [logoError, setLogoError] = useState(false);

  // Size mappings
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-28 h-28',
    nav: 'w-[96px] h-[96px]',
    lg: 'w-40 h-40',
    xl: 'w-52 h-52'
  };

  const textSizes = {
    sm: 'text-5xl',
    md: 'text-7xl',
    nav: 'text-[7rem]',
    lg: 'text-9xl',
    xl: 'text-[10rem]'
  };

  const iconSizes = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    nav: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="relative">
        <div className={`${sizeClasses[size]} flex items-center justify-center transform group-hover:scale-105 transition-all duration-300`}>
          {logoError ? (
            <div className={`${sizeClasses[size]} bg-gradient-to-br from-[#00d9ff] to-[#0066ff] flex items-center justify-center border border-[rgba(0,217,255,0.3)]`} style={{ clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 100%, 8px 100%)' }}>
              <TrophyIcon className={`${iconSizes[size]} text-white`} />
            </div>
          ) : (
            <img 
              src="/images/logo.png" 
              alt="DIOS10 Logo" 
              className="w-full h-full object-contain"
              onError={() => setLogoError(true)}
            />
          )}
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#00d9ff] to-[#0066ff] opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-300"></div>
      </div>
      {showText && (
        <span className={`${textSizes[size]} font-black text-white uppercase logo-text-white`} style={{ 
          fontFamily: '"Orbitron", "Rajdhani", "Bebas Neue", "Roboto Condensed", Impact, Arial Black, sans-serif', 
          fontWeight: 900,
          letterSpacing: '0.15em',
          color: '#FFFFFF',
          textShadow: '0 0 10px rgba(0, 0, 0, 0.8), 2px 2px 4px rgba(0, 0, 0, 0.9), 4px 4px 8px rgba(0, 0, 0, 0.7)',
          WebkitTextStroke: '1px rgba(0, 0, 0, 0.5)'
        }}>
          DIOS10
        </span>
      )}
    </div>
  );
};

export default Logo;

